import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

const PartnerHook = () => {

  const [statePartner, setStatePartner] = useState({
    enroling: false,
    partnerError: undefined,
    partnerSuccess: undefined,
  });

  const { partners, success, error, enroling } = useSelector(
    (state) => state.PartnerReducer
  );
  const [partnerList, setPartnerList] = useState([]);

  useEffect(() => {
    setPartnerList(partners);
  }, [partners]);

  useEffect(() => {

    if (success?.message !== '' && success.message !== undefined) {
      console.log(success);
      setStatePartner({ ...statePartner, partnerSuccess: success });
      // return;
    }
    if (error?.message) {
      setStatePartner({ ...statePartner, partnerError: error });

      // return;
    }

    if (enroling !== statePartner.enroling) {
      setStatePartner({ ...statePartner, enroling: enroling });
    }

  }, [success, error, enroling]);


  const clearMessageEnrole = () => {
    setStatePartner({ ...statePartner, partnerError: undefined, partnerSuccess: undefined });
  }

  // useEffect(() => {
  //   setStatePartner({ ...statePartner, enroling: enroling });
  // }, [enroling]);


  return { statePartner, partnerList, success, error, clearMessageEnrole };
};
export default PartnerHook;
